import clientAuth from "../clientAuth";

export default {
  // get camper 
  camper_index: () => clientAuth.get("camper/index"),
  // get camperType
  camperType: () => clientAuth.get("camperType/index"),
  // get videoType  
  videoType: () => clientAuth.get("videoType/index"),
  
  index: () => clientAuth.get("tutorial/index"),
  
  store: (userData) => clientAuth.post('tutorial/store', { json: userData }),
  

  show:(id)=>clientAuth.get('tutorial/show/'+id),

  update:(id,userData)=>clientAuth.post(`tutorial/update/${id}`,{json:userData}),

  destroy:(id)=>clientAuth.delete(`tutorial/destroy/${id}`),
};